import type { Translations } from './en';

const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';

const ar: Translations = {
  common: {
    appName: appName,
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    delete: 'حذف',
    edit: 'تعديل',
    back: 'رجوع',
    search: 'بحث',
    noResults: 'لا توجد نتائج',
    error: 'حدث خطأ',
    success: 'نجح',
  },
  header: {
    searchPlaceholder: 'ابحث عن الأخبار والمواضيع والوسوم...',
    searchPlaceholderMobile: 'بحث...',
    home: 'الرئيسية',
    hotgirl: 'فتيات',
    coser: 'كوسر',
    model: 'موديل',
    upload: 'رفع',
    notifications: 'الإشعارات',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
  },
  footer: {
    tagline: `أفضل منصة لمشاركة صور الكوسر والفتيات والموديل على ${appName}`,
    copyright: `© {year} ${appName}. جميع الحقوق محفوظة.`,
    sections: { explore: 'استكشاف', account: 'الحساب', support: 'الدعم' },
    links: {
      home: 'الرئيسية', hotgirl: 'فتيات', coser: 'كوسر', model: 'موديل', aoDai: 'آو داي',
      login: 'تسجيل الدخول', register: 'إنشاء حساب', upload: 'رفع صورة', dashboard: 'لوحة التحكم',
      terms: 'الشروط والأحكام', privacy: 'سياسة الخصوصية', report: 'الإبلاغ عن انتهاك', contact: 'اتصل بنا',
    },
  },
  collections: {
    title: 'المجموعات',
    createAlbum: 'إنشاء ألبوم',
    saved: 'المحفوظات',
    noSaved: 'لا توجد صور محفوظة بعد',
    noSavedHint: 'استكشف الصور الآن →',
    removedSave: 'تم إلغاء الحفظ',
    createModalTitle: 'إنشاء ألبوم جديد',
    albumNamePlaceholder: 'اسم الألبوم...',
    cancel: 'إلغاء',
    create: 'إنشاء',
    albumCreated: 'تم إنشاء الألبوم',
  },
  home: {
    title: 'اكتشف',
    titleHighlight: 'الجمال',
    titleSuffix: 'الحياة',
    subtitle: 'آلاف الصور من الكوسر والفتيات والموديل تُحدَّث يومياً',
    sortNewest: 'الأحدث',
    sortTrending: 'الرائج',
    sortPopular: 'الأكثر شعبية',
    allCategories: 'الكل',
    noMorePosts: 'لقد شاهدت كل الصور',
  },
  auth: {
    login: {
      title: 'سجّل دخولك للمتابعة',
      continueWithGoogle: 'المتابعة مع Google',
      orLoginWithEmail: 'أو سجّل الدخول بالبريد الإلكتروني',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      submitButton: 'تسجيل الدخول',
      loading: 'جاري تسجيل الدخول...',
      noAccount: 'ليس لديك حساب؟',
      registerLink: 'سجّل الآن',
      errorCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
      successLogin: 'تم تسجيل الدخول بنجاح!',
    },
    register: {
      title: 'إنشاء حساب مجاني',
      displayName: 'الاسم المعروض',
      displayNamePlaceholder: 'محمد علي',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      passwordPlaceholder: '8 أحرف على الأقل',
      confirmPassword: 'تأكيد كلمة المرور',
      submitButton: 'إنشاء حساب',
      loading: 'جاري إنشاء الحساب...',
      hasAccount: 'لديك حساب بالفعل؟',
      loginLink: 'تسجيل الدخول',
      errorPasswordMismatch: 'كلمتا المرور غير متطابقتين',
      errorPasswordLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
      errorGeneric: 'فشل إنشاء الحساب',
      successRegister: 'تم إنشاء الحساب بنجاح!',
      emailTaken: 'البريد الإلكتروني مستخدم بالفعل',
      serverError: 'خطأ في الخادم، يرجى المحاولة مرة أخرى لاحقًا',
    },
    forgotPassword: {
      title: 'نسيت كلمة المرور',
      subtitle: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين',
      email: 'البريد الإلكتروني',
      submitButton: 'إرسال رابط إعادة التعيين',
      backToLogin: 'العودة لتسجيل الدخول',
      sending: 'جاري الإرسال...',
      emailSent: 'تم إرسال البريد الإلكتروني!',
      checkEmail: 'تحقق من صندوق الوارد الخاص بـ {email} للحصول على رابط إعادة تعيين كلمة المرور.',
      instructions: 'أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.',
    },
  },
  userMenu: {
    dashboard: 'لوحة التحكم',
    collections: 'المجموعات',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
  },
  settings: {
    title: 'إعدادات الحساب',
    profile: {
      nav: 'الملف الشخصي',
      title: 'معلومات الملف الشخصي',
      displayName: 'الاسم المعروض',
      username: 'اسم المستخدم',
      website: 'الموقع الإلكتروني',
      bio: 'نبذة عني',
      bioPlaceholder: 'عرّف بنفسك...',
      changeAvatar: 'تغيير الصورة الرمزية',
      avatarHint: 'JPG، PNG، WebP بحد أقصى 5MB',
      saveButton: 'حفظ التغييرات',
      saving: 'جاري الحفظ...',
      savedSuccess: 'تم حفظ التغييرات',
    },
    password: { 
      nav: 'كلمة المرور',
      title: 'تغيير كلمة المرور',
      fields: {
        currentPassword: 'كلمة المرور الحالية',
        newPassword: 'كلمة المرور الجديدة',
        confirm: 'تأكيد كلمة المرور الجديدة',
      },
      errors: {
        confirm: 'كلمة المرور الجديدة غير متطابقة',
        minLength: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
      },
      success: 'تم تغيير كلمة المرور',
      saving: 'جاري الحفظ...',
      submit: 'تغيير كلمة المرور',
    },
    notifications: { 
      nav: 'الإشعارات',
      title: 'إعدادات الإشعارات',
      options: {
        likes: 'عندما يتم الإعجاب بصورة لك',
        comments: 'عندما يتم التعليق على منشورك',
        replies: 'عندما يتم الرد على تعليقك',
        follows: 'عندما يتابعك شخص ما',
        approved: 'عندما يتم الموافقة على المنشور الخاص بك',
        email_digest: 'ملخص البريد الإلكتروني الأسبوعي',
        marketing: 'إشعارات العروض الترويجية والفعاليات',
      },
      saveSuccess: 'تم حفظ إعدادات الإشعارات',
      saving: 'جاري الحفظ...',
      saveButton: 'حفظ الإعدادات',
    },
    security: { 
      nav: 'الأمان',
      twoFactorAuth: 'المصادقة الثنائية (2FA)',
      twoFactorAuthHint: 'عزز الأمان باستخدام رمز التحقق من التطبيق',
      comingSoon: 'قريبًا',
      activeSessions: 'الجلسات النشطة',
      currentBrowser: 'المتصفح الحالي',
      lastLogin: 'آخر تسجيل دخول',
      active: 'نشط',
      dangerZone: 'منطقة الخطر',
      deleteAccountHint: 'سيؤدي حذف الحساب إلى إزالة جميع بياناتك بشكل دائم.',
      deleteAccount: 'حذف الحساب',
    },
  },
  post: {
    likes: '{count} إعجاب',
    views: '{count} مشاهدة',
    shares: '{count} مشاركة',
    comments: '{count} تعليق',
    save: 'حفظ',
    saved: 'محفوظ',
    share: 'مشاركة',
    linkCopied: 'تم نسخ الرابط!',
    follow: 'متابعة',
    following: 'تتابع',
    relatedPosts: 'منشورات ذات صلة',
    commentPlaceholder: 'اكتب تعليقاً...',
    commentLoginPlaceholder: 'تسجيل الدخول للتعليق...',
    commentSubmit: 'نشر',
    commentSubmitting: 'جاري النشر...',
    noComments: 'لا توجد تعليقات بعد. كن أول من يعلّق!',
    savedToCollection: 'تم الحفظ في المجموعة',
    removedFromCollection: 'تم إلغاء الحفظ',
    description: 'الوصف',
    profileView: 'عرض الملف الشخصي',
    replies: 'ردود',
    unsaved: 'تمت الإزالة من المحفوظات',
    liked: 'أعجبني',
    like: 'إعجاب',
  },
  notifications: {
    title: 'الإشعارات',
    empty: 'لا توجد إشعارات',
    markAllRead: 'تعليم الكل كمقروء',
    types: {
      like_post: 'أحببت صورتك',
      comment: 'علق على صورتك',
      reply: 'رد على تعليقك',
      follow: 'تابعك',
      approve: 'تمت الموافقة على منشورك',
      reject: 'تم رفض منشورك',
      system: 'إشعار النظام',
    },
  },
  search: {
    title: 'نتائج البحث عن',
    result: 'نتيجة',
    tryOtherKeywords: 'حاول مع كلمات مفتاحية أخرى...',
    noResults: 'لا توجد نتائج لـ',
    placeholder: 'بحث...',
    thisHashtag: 'صور بهذا الوسم',
    results: 'نتيجة',
  },
  upload: {
    title: 'رفع صورة',
    dragDrop: 'اسحب وأفلت أو انقر للاختيار',
    supportedFormats: 'يدعم JPG، PNG، WebP، GIF',
    submit: 'نشر',
    submitting: 'جاري النشر...',
    titleField: 'العنوان',
    cover: 'الغلاف',
    titlePlaceholder: 'أدخل عنوانًا جذابًا...',
    descriptionField: 'الوصف',
    descriptionPlaceholder: 'وصف تفصيلي لمجموعة الصور...',
    hashtagsField: 'الوسوم',
    statusField: 'الحالة',
    statusPublic: 'عام',
    statusPrivate: 'خاص',
    statusDraft: 'مسودة',
    error: 'خطأ أثناء التحميل',
    errorSelect: 'حدد صورة واحدة على الأقل',
    errorTitle: 'أدخل عنوانًا',
    photos: 'صور',
    uploading: 'جاري التحميل...',
  },
  notFound: {
    title: 'الصفحة غير موجودة',
    subtitle: 'الصفحة التي تبحث عنها غير موجودة.',
    backHome: 'العودة للرئيسية',
  },
  liked: {
    title: 'المنشورات التي أعجبتك',
    empty: 'لا توجد منشورات أعجبتك بعد.',
  },
  user: {
    unknown: 'مجهول',
  },
  globalError: {
    title: 'حدث خطأ',
    subtitle: 'نعتذر عن الإزعاج. يرجى المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
  },
  username: {
    posts: 'المنشورات',
    likes: 'الإعجابات',
    followers: 'المتابعون',
    following: 'المتابعة',
    editProfile: 'تعديل الملف الشخصي',
    message: 'رسالة',
    noPosts: 'لا توجد منشورات بعد.',
    bio: 'عرض صور ',
    notFound: 'المستخدم غير موجود',
  },
  topic: {
    notFound: 'الموضوع غير موجود',
    viewTitle: 'عرض صور الموضوع ',
  },
  dashboard: {
    title: 'لوحة التحكم',
    welcome: 'مرحبًا',
    stats: {
      posts: 'المنشورات',
      views: 'المشاهدات',
      likes: 'الإعجابات',
      comments: 'التعليقات',
    },
  },
  adsblock: {
    title: "أنت تستخدم مانع الإعلانات",
    description: "يرجى تعطيل مانع الإعلانات لعرض الصور بجودة عالية ومساعدتنا في إبقاء الموقع مجانيًا.",
    action: "لقد قمت بتعطيله — إعادة التحميل",
    cancel: "تخطي"
  },
  pwa: {
    title: `تثبيت ${appName} لتجربة أفضل!`,
    iosSubtitle: 'اضغط على مشاركة → إضافة إلى الشاشة الرئيسية',
    androidSubtitle: 'احصل على إشعارات حول مجموعات الصور الجديدة بمجرد إصدارها',
    installButton: 'تثبيت',
    disclaimer: 'تثبيت سريع، لا حاجة لمتجر التطبيقات.',
  },
  autotrans: {
    title: 'تمت الترجمة تلقائيًا',
    translated: 'الترجمة',
    origin: 'المحتوى الأصلي',
  },
  subscription: {
    title: 'الاشتراك في الإشعارات',
    description: 'احصل على إشعارات حول مجموعات الصور الجديدة بمجرد إصدارها.',
    subscribeButton: 'اشتراك',
    unsubscribeButton: 'إلغاء الاشتراك',
    subscribed: 'أنت مشترك في الإشعارات.',
    unsubscribed: 'لقد ألغيت اشتراكك في الإشعارات.',
    error: 'حدث خطأ أثناء تحديث اشتراكك. يرجى المحاولة مرة أخرى.',
    success_tit: '🎉 تم تفعيل الإشعارات!',
    denied_tit: 'تم رفض الإشعارات',
    error_tit: 'حدث خطأ',
    success_des: 'ستتلقى إشعارات عندما يكون هناك محتوى جديد متاح.',
    denied_des: 'يمكنك إعادة تفعيلها في إعدادات المتصفح الخاصة بك.',
    error_des: 'يرجى المحاولة مرة أخرى لاحقًا.',
    skip: 'تخطي',
    processing: 'جاري المعالجة...',
    noti: 'تفعيل الإشعارات',
    rule: 'عرض الإشعارات فقط للمحتوى الجديد.',
    notify_title: `الإشعارات - ${appName}`,
    notify_body: "تم إصدار المعرض الجديد. تحقق منه الآن!",
  },
  contact: {
    title: 'اتصل بنا',
    subtitle: 'نود أن نسمع منك! يرجى ملء النموذج أدناه وسنعود إليك في أقرب وقت ممكن.',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    subject: 'الموضوع',
    message: 'الرسالة',
    submitButton: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
    successTitle: 'تم إرسال الرسالة!',
    successMessage: 'شكرًا لتواصلك معنا. سنعود إليك قريبًا.',
    errorTitle: 'حدث خطأ',
    errorMessage: 'حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى لاحقًا.',
    res_time_title: 'وقت الاستجابة',
    res_time: 'نحن عادةً ما نرد في غضون 1-3 أيام عمل.',
    report_content: 'الإبلاغ عن المحتوى',
    report_content_hint: 'للإبلاغ عن منشور أو مستخدم، استخدم زر الإبلاغ مباشرةً على المحتوى أو اختر "الإبلاغ عن المحتوى" أعلاه.',
    value_default: 'اختر موضوعًا',
    value_general: 'استفسار عام',
    value_report: 'الإبلاغ عن المحتوى',
    value_account: 'مشكلة في الحساب',
    value_business: 'عمل / شراكة',
    value_feedback: 'الملاحظات والاقتراحات',
    value_other: 'أخرى'
  },
  language: {
    label: 'اللغة',
    en: 'English', vi: 'Tiếng Việt', zh: '中文', ja: '日本語',
    ko: '한국어', ar: 'العربية', fr: 'Français', es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
};

export default ar;
